import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { dnmFilterFields } from "./fields";

const DnmFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => dnmFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={5} />;
};

export default DnmFilter;
